import { format, parse } from 'date-fns';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Container, Grid, GridColumn, Heading, Text } from 'telia-front-react';
import { useStores } from '../../stores/RootStore';

export interface NewsDetailsProps {
  title: string;
  displayDate: string;
  children: React.ReactNode;
}

const NewsDetailsContainer = observer((props: NewsDetailsProps): React.JSX.Element => {
  const { languageStore } = useStores();
  const { title, displayDate, children } = props;
  const resolvedDateFormat = 'd. MMMM yyyy';

  return (
    <Container>
      <Grid>
        <GridColumn width={['xs-12', 'sm-6', 'lg-8']}>
          <Text>
            <Heading level={1} className="h2">
              {title}
            </Heading>
            <div className="text-small">
              <time dateTime={displayDate}>
                {format(parse(displayDate, 'dd.MM.yyyy', Date.now()), resolvedDateFormat, { locale: languageStore.currentLocale })}
              </time>
            </div>
            <Text className="text__margin-double">{children}</Text>
          </Text>
        </GridColumn>
      </Grid>
    </Container>
  );
});

export default NewsDetailsContainer;
